import React, { useState } from 'react';
import { View, TouchableOpacity, Text, ActivityIndicator } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';

import HeaderDefault from '../../components/HeaderDefault';
import { LinearGradient } from 'expo-linear-gradient';
import { toast } from '../../utils/toast';

import api from '../../services/api';

import styles from './styles';

const DeleteAccount = () => {
    const [isLoading, setIsLoading] = useState(false);
    const navigation = useNavigation();

    const deleteAccount = async () => {
        setIsLoading(true);
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        api.delete(`/clients/delete/client`, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                toast("Conta excluída.", "#080");

                setIsLoading(false);
                navigation.navigate('Login');
            })
            .catch((error) => {
                console.log(error)
                toast("Houve um erro, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }
    return (
        <>
            <HeaderDefault title={'Excluir conta'} />

            <Text style={styles.textInfo}>
                Tem certeza de que deseja excluir sua conta?
            </Text>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={deleteAccount}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#8F0101", "#FE5353"]}
                        style={styles.btn}
                    >
                        {isLoading ? (
                            <ActivityIndicator color="#fff" size="small" />
                        ) : (
                            <Text style={styles.textBtn}>EXCLUIR</Text>
                        )}
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default DeleteAccount;